exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".location-card[data-v-41b359ca] {\n  display: block;\n  position: relative;\n}\n.location-card .xsmall[data-v-41b359ca] {\n  line-height: 1.2;\n}\n.location-card .image-wrapper[data-v-41b359ca] {\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n}\n.location-card .image-wrapper img[data-v-41b359ca] {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  font-family: \"object-fit: cover;\";\n  transition: transform 0.15s;\n}\n.location-card:hover img[data-v-41b359ca] {\n  transform: scale(1.1);\n}", ""]);

// exports
